/* import __COLOCATED_TEMPLATE__ from './compare-plans.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();